import { memoize as _memoize } from 'lodash-es'

// Loading all the CLDR data can be expensive so cache the Format instances.
const getFormatter = _memoize(
  (options) => new Intl.NumberFormat('en-US', options),
  (options) => JSON.stringify(options),
)

function prettifyNumber(n: number, options = {}) {
  const formatter = getFormatter(options)
  return formatter.format(n)
}

export default prettifyNumber
